import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 2,
  class: "upload-editor__actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FilePreview = _resolveComponent("FilePreview")
  const _component_IconPlus = _resolveComponent("IconPlus")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")
  const _component_AudioPlayer = _resolveComponent("AudioPlayer")
  const _component_NewMessage = _resolveComponent("NewMessage")
  const _component_NcModal = _resolveComponent("NcModal")

  return ($options.showModal)
    ? (_openBlock(), _createBlock(_component_NcModal, {
        key: 0,
        ref: "modal",
        size: $options.isVoiceMessage ? 'small' : 'normal',
        "close-on-click-outside": false,
        "label-id": $setup.dialogHeaderId,
        onClose: $options.handleDismiss
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "upload-editor",
            onDragover: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.handleDragOver && $options.handleDragOver(...args)), ["prevent"])),
            onDragleave: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.handleDragLeave && $options.handleDragLeave(...args)), ["prevent"])),
            onDrop: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.handleDropFiles && $options.handleDropFiles(...args)), ["prevent"]))
          }, [
            (!$options.isVoiceMessage)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h2", {
                    id: $setup.dialogHeaderId,
                    class: "hidden-visually"
                  }, _toDisplayString($options.t('spreed', 'Upload from device')), 9, _hoisted_1),
                  _createElementVNode("input", {
                    id: "file-upload",
                    ref: "fileUploadInput",
                    multiple: "",
                    type: "file",
                    class: "hidden-visually",
                    onChange: _cache[0] || (_cache[0] = (...args) => ($options.handleFileInput && $options.handleFileInput(...args)))
                  }, null, 544),
                  _createVNode(_component_TransitionWrapper, {
                    class: _normalizeClass(["upload-editor__previews", { 'dragging-over': $setup.isDraggingOver }]),
                    name: "fade",
                    tag: "div",
                    group: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.files, (file) => {
                        return (_openBlock(), _createBlock(_component_FilePreview, {
                          key: file[1].temporaryMessage.id,
                          token: $setup.token,
                          "is-upload-editor": "",
                          file: file[1].temporaryMessage.messageParameters.file,
                          onRemoveFile: $options.handleRemoveFileFromSelection
                        }, null, 8, ["token", "file", "onRemoveFile"]))
                      }), 128)),
                      _createVNode(_component_NcButton, {
                        "aria-label": $options.addMoreAriaLabel,
                        variant: "tertiary",
                        class: "add-more-button",
                        size: "large",
                        onClick: $options.clickImportInput
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconPlus, { size: 48 })
                        ]),
                        _: 1
                      }, 8, ["aria-label", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ], 64))
              : (_openBlock(), _createBlock(_component_AudioPlayer, {
                  key: 1,
                  name: $options.voiceMessageName,
                  "local-url": $options.voiceMessageLocalURL
                }, null, 8, ["name", "local-url"])),
            (!$options.supportMediaCaption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_NcButton, {
                    variant: "tertiary",
                    onClick: $options.handleDismiss
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.t('spreed', 'Dismiss')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_NcButton, {
                    ref: "submitButton",
                    variant: "primary",
                    onClick: $options.handleLegacyUpload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.t('spreed', 'Send')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : (_openBlock(), _createBlock(_component_NewMessage, {
                  key: 3,
                  ref: "newMessage",
                  role: "region",
                  class: "upload-editor__textfield",
                  upload: "",
                  dialog: "",
                  token: $setup.token,
                  container: $setup.modalContainerId,
                  "aria-label": $options.t('spreed', 'Post message'),
                  onSubmit: $options.handleUpload,
                  onDismiss: $options.handleDismiss
                }, null, 8, ["token", "container", "aria-label", "onSubmit", "onDismiss"]))
          ], 32)
        ]),
        _: 1
      }, 8, ["size", "label-id", "onClose"]))
    : _createCommentVNode("", true)
}